// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__reJSZ","search":"Settings_search__t1DmR","filter":"Settings_filter__3QWe7"};